// Form validation for time trigger form

import { plaintextValidator } from '../fields';
import ruleBuilder from '../utils/RuleBuilder';

// TODO: Find mandatory fields in schema and update fields

// TODO: After ensuring correct state structure move operand constraints to another file

const config = { mandatory: true };

export default {
  name: plaintextValidator(config),
  event: plaintextValidator(config),
  ruleCondition: { presence: { allowEmpty: false } },
  ...ruleBuilder('ruleCondition.operands')
};
